import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class AppMessageCommentQueryCriteriaClass extends BaseCriteriaModel {
  guid?: Optional<string> = Optional.empty();
  parent_guid?: Optional<string> = Optional.empty();
  app_login_subject_guid?: Optional<string> = Optional.empty();
  ref_type?: Optional<string> = Optional.empty();
  ref_column?: Optional<string> = Optional.empty();
  ref_row?: Optional<string> = Optional.empty();
  ref_table?: Optional<string> = Optional.empty();
  value_type?: Optional<string> = Optional.empty();
  value_rating?: Optional<number> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();
  created_date_from?: Optional<string> = Optional.empty();
  created_date_to?: Optional<string> = Optional.empty();
}

export class AppMessageCommentCriteriaModelQuery {
  query = '';

  constructor(appMessageCommentCriteriaModel: AppMessageCommentQueryCriteriaClass) {

    if (!appMessageCommentCriteriaModel) {
      return;
    }

    this.query += appMessageCommentCriteriaModel.guid.filter(x => x !== '').map(x => '&guid=' + x).orElse('');
    this.query += appMessageCommentCriteriaModel.parent_guid.filter(x => x !== '').map(x => '&parent_guid=' + x).orElse('');
    this.query += appMessageCommentCriteriaModel.app_login_subject_guid.filter(x => x !== '').map(x => '&app_login_subject_guid=' + x).orElse('');
    this.query += appMessageCommentCriteriaModel.ref_type.filter(x => x !== '').map(x => '&ref_type=' + x).orElse('');
    this.query += appMessageCommentCriteriaModel.ref_column.filter(x => x !== '').map(x => '&ref_column=' + x).orElse('');
    this.query += appMessageCommentCriteriaModel.ref_row.filter(x => x !== '').map(x => '&ref_row=' + x).orElse('');
    this.query += appMessageCommentCriteriaModel.ref_table.filter(x => x !== '').map(x => '&ref_table=' + x).orElse('');
    this.query += appMessageCommentCriteriaModel.value_type.filter(x => x !== '').map(x => '&value_type=' + x).orElse('');
    this.query += appMessageCommentCriteriaModel.value_rating.filter(x => x !== null).map(x => '&value_rating=' + x).orElse('');
    this.query += appMessageCommentCriteriaModel.value_string.filter(x => x !== null).map(x => '&value_string=' + x).orElse('');
    this.query += appMessageCommentCriteriaModel.created_date_from.filter(x => x !== '').map(x => '&created_date_from=' + x).orElse('');
    this.query += appMessageCommentCriteriaModel.created_date_to.filter(x => x !== '').map(x => '&created_date_to=' + x).orElse('');

    this.query += '&status=' + appMessageCommentCriteriaModel.status;
    this.query += '&orderBy=' + appMessageCommentCriteriaModel.orderBy;
    this.query += '&order=' + appMessageCommentCriteriaModel.order;
    this.query += '&offset=' + appMessageCommentCriteriaModel.offset + '&limit=' + appMessageCommentCriteriaModel.limit;
  }
}
